/* eslint-disable guard-for-in */
/* eslint-disable @typescript-eslint/no-invalid-this */
/* eslint-disable react/no-this-in-sfc */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Dialog } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { getUserDetails } from '../../../utils/orgName';
import { API } from '../../../api';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { toast } from 'react-toastify';
import moment from 'moment';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import _ from 'lodash';
import { userInfoUpdate } from '../../../redux/slices/user-profile/userProfieSlice';
import countryCodeArray from '../../../constants/countrycode';
import { disabilityPopupActions } from '../../../redux/slices/disability/disabilityPopupSlice';
import { countries } from '../../profile-page/countryData';
import { timezones } from '../../profile-page/timeZones';
// import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Controller, SubmitHandler, FieldValues, useForm } from 'react-hook-form';
// import ChatAvatarComponent from "../tabs/chat/ChatAvatarComponent";
import { validatePhoneNumber } from '../../../constants/PhoneNumberValidator';
import PhoneInput from '../../../constants/PhoneInput';
import { fetchOrgDetails } from '../../../redux/slices/orgDetails/orgDetailsSlice';
import ROLES from '../../../utils/roles';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import EditProfileForm from './EditProfileForm';
import { popupActions } from '../../../redux/slices/onboardingPopupsSlice';
import CommonModalHeader from '../../../components/DialogUi/CommonModalHeader';
import { useIsMobileApp } from '../../../mobile/mobileApp';

interface EditProfileProps {
  open?: boolean;
  onClose?: () => void;
  disableClose?: boolean;
}

// Dark-mode theming for the Personal information dialog. The app's MUI theme
// is light by default (white paper, #EFF0F4 input borders, dark-on-light
// text), but the platform runs in dark mode — so the modal body was rendering
// as a white sheet. These overrides bring the dialog in line with the rest of
// the dark UI (bg #0F0F0F, borders #2A2A2A, text #FDFDFD). Many theme rules use
// `!important`, so the overrides that fight them do too.
const darkDialogSx = {
  bgcolor: '#0F0F0F',
  backgroundImage: 'none',
  color: '#FDFDFD',
  // Field labels
  '& .MuiInputLabel-root': { color: '#ABB5BE !important' },
  // Typed values / textarea text
  '& .MuiInputBase-input': { color: '#FDFDFD !important', WebkitTextFillColor: '#FDFDFD' },
  '& textarea': { color: '#FDFDFD !important' },
  '& .MuiAutocomplete-input': { color: '#FDFDFD !important' },
  // Input fills + borders
  '& .MuiOutlinedInput-root': {
    backgroundColor: '#1C1C1C',
    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#2A2A2A !important' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#444444 !important' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#F79420 !important' }
  },
  // Placeholders / guide text — intentionally dim (dimmer than the old #68717A)
  // so hints aren't mistaken for entered values, which render in bright #FDFDFD.
  '& input::placeholder, & textarea::placeholder': { color: '#50565E !important', opacity: 1 },
  // Icons: dropdown arrows, calendar, clear
  '& .MuiSvgIcon-root': { color: '#ABB5BE' },
  // Disabled Email field — dark fill (overriding the theme's light #EFF0F4) with
  // muted-but-legible text, so "not editable" reads from the greyed copy rather
  // than a light box. High specificity + !important to beat the theme rule.
  '& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: '#151515 !important',
    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#2A2A2A !important' }
  },
  '& .MuiInputBase-root .MuiInputBase-input.Mui-disabled': {
    background: '#151515 !important',
    WebkitTextFillColor: '#8A94A0 !important',
    color: '#8A94A0 !important'
  },
  // Helper / counter text
  '& .MuiFormHelperText-root:not(.Mui-error)': { color: '#68717A' },
  // Dividers
  '& .MuiDivider-root': { borderColor: '#2A2A2A !important' },
  // Profile-image upload square (CSS class defaults to light #EFF0F4)
  '& .profileImageBox': { backgroundColor: '#1C1C1C !important', border: '1px solid #2A2A2A' }
};

// const userData = {
//   firstName: getUserDetails().firstName,
//   lastName: getUserDetails().lastName,
//   gender: '',
//   country: '',
//   phoneNumber: '',
//   ethnicity: '',
//   timezone: '',
//   headshot: getUserDetails().picture,
//   firstGenStudent: 'No',
//   email: getUserDetails().email,
//   category: '',
//   dob: ''
// };
const EditProfile: React.FC<EditProfileProps> = ({ open: openOverride, onClose, disableClose }) => {
  const isMobileApp = useIsMobileApp();
  const { open, disable } = useAppSelector((state) => state.onboardingPopups.data.profile);
  const isOpen = openOverride ?? open;
  const isDisableClose = disableClose ?? disable;

  const dispatch = useAppDispatch();

  const handleClose = () => {
    if (isDisableClose) return;
    if (onClose) {
      onClose();
      return;
    }
    dispatch(popupActions.updatePopups({ profile: { open: false, disable: false } }));
  };

  useEffect(() => {
    return () => {
      handleClose();
    };
  }, []);
  useEffect(() => {}, [isOpen]);
  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      disableEnforceFocus
      // Phone: a full-screen sheet whose form scrolls under a fixed title and actions.
      scroll={isMobileApp ? 'paper' : 'body'}
      fullScreen={isMobileApp}
      fullWidth
      data-testid="profile-edit-dialog"
      PaperProps={{ sx: darkDialogSx }}
    >
      <CommonModalHeader title={`Personal information`} handleCloseModal={handleClose} />
      <EditProfileForm onClose={handleClose} dark />
    </Dialog>
  );
};

export default EditProfile;
